function CartLayer() {

    const cleanString = function(str) {
        // datalayer.liquid
        // replace: '&amp;', '&' |  replace: '&lt;br&gt;', ' ' |  replace: '<br>', ' '
        str = str || ''
        return str.replace("&amp", "&")
            .replace("&lt;br&gt;", " ")
            .replace("<br>", " ")
    }

    const updateDataLayerBeginCheckout = function(shopCurrency, discountTitle, cartData) {

        const purchaseItems = []

        cartData.items.forEach((lineItem) => {

            let purchaseDiscount = 0;
            if (lineItem.discount_allocations && lineItem.discount_allocations.length > 0) {
                lineItem.discount_allocations.forEach((discount) => {
                    purchaseDiscount += (discount / 100.00);
                })
            }

            if (window.cartjs_items_collections) {
                lineItem.collection_title = window.cartjs_items_collections[lineItem.id] || ''
            }

            purchaseItems.push({
                'item_id': lineItem.sku,
                'item_name': cleanString(lineItem.product_title),
                'item_variant': cleanString(lineItem.variant_title),
                'item_brand': cleanString(lineItem.vendor),
                'item_category': cleanString(lineItem.product_type || ''),
                'price': lineItem.final_price / 100.00,
                'discount': purchaseDiscount,
                'quantity': lineItem.quantity
            })
        })

        const totalPrice = Math.floor(cartData.total_price / 100.0)
        const dataLayerObject = {
            'event': 'begin_checkout',
            'ecommerce': {
                'currency': shopCurrency,
                'value': totalPrice,
                'coupon': discountTitle,
                'items': purchaseItems
            }
        }

        console.log(dataLayerObject);

        window.dataLayer.push(dataLayerObject);

        console.log('begin_checkout done')
    }

    const processBeginCheckout = function(shopCurrency, discountTitle) {
        // fetch json cart
        fetch('/cart.json', {
            credentials: 'same-origin',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
        }).then(function (cart) {
            cart.json().then(function (content) {

                updateDataLayerBeginCheckout(shopCurrency, discountTitle, content)

                const submitButton = document.querySelector('#checkout')
                if (submitButton) {
                    submitButton.click()
                }
            })
        });
    }

    return {
        processBeginCheckout: processBeginCheckout
    }
}


document.addEventListener("DOMContentLoaded", (event) => {

    console.log('cart-layer loaded')
});

function beginCheckoutCart(shopCurrency, discountTitle) {
    const cartLayer2 = new CartLayer()
    cartLayer2.processBeginCheckout(shopCurrency, discountTitle)
}
